require("_css/main.styl");

const sys = require("_js/sys.js");
const html5 = require("_js/html5.js");
const ua = require("_js/useragent.js");
const webgl = require("_js/webgl.js");
const logger = require("_js/logger.js");
const {startInitRequest} = require("./js/initRequest");
const {loadAndStartPreloader, destroyPreloader} = require("./js/preloader");
const {showError} = require("./js/ErrorOverlay");
const {JSON_LIST_PATH, ASSETS_PATH} = require("./js/CIConstants");

const extraParams = {
	disableMobileFullscreen: html5.disableMobileFullscreen
};
let isNeedShowPreloader = true;
let isPreloaderComplete = false;
let isGameLoaded = false;

const PRELOADER_SUPPS = [215, 240];

const EXTRA_PARAMS_LIST = ["disable_gamble", "disable_buying", "disable_extra_math"];

// Get provider prefix for jackpot_resources from game_name
function getProviderPrefix(game) {
	switch (game.split("_")[0]) {
		case "aa": return "aa_";
		case "rpls": return "rpls_acms_";
		case "gmz": return "gmz_";
		case "open": if (game.split("_")[1] === "tabs") return "open_tabs_";
		case "abx": if (game.split("_")[1] === "scratch") {
			return "abx_scratch_";
		} else {
			return "abx_";
		}
		case "irv": return "irv_";
		default: return "";
	}
}

function loadGameConfig(params) {
	const path = params.path;
	let gameConfig = {};
	let jpConfig = {};

	loadDataConfig(path, params.game, false, params.hash)
		.then((data) => (gameConfig = data))
		.then(() => loadDataConfig(path, `${getProviderPrefix(params.game)}jackpot_resources`, true, params.jackpot_resources_hash))
		.then((data) => (jpConfig = data))
		.finally(() => {
			const jpResoucesName = getNameByConfig(jpConfig);

			extraParams.jpFolder = jpResoucesName
				? `${path}${jpResoucesName}/`
				: null;

			sendInitRequest(gameConfig, params);
		});
}

function sendInitRequest(app, params) {
	startInitRequest(app, params)
		.then((dataProps) => {
			EXTRA_PARAMS_LIST.forEach((param) => {
				if (params[param] !== undefined) {
					extraParams[param] = params[param];
				}

				if (dataProps[param] !== undefined) {
					extraParams[param] = dataProps[param];
				}
			});

			initGameContent(app, params);
		})
		.catch((err) => showError(err));
}

function getNameByConfig(config) {
	return (config.html5 && config.html5.app && config.html5.app[0]) || null;
}

function loadDataConfig(path, name, isSkipJsonData, hash) {
	return new Promise((resolve) => {
		if (window.JSON_DATA === undefined || isSkipJsonData) {
			// eslint-disable-next-line max-len
			const url = `${path + (path.endsWith("/") ? "" : "/")}${JSON_LIST_PATH}/${name}.json?t=${hash ? hash : (new Date().getTime())}`;
			const req = new XMLHttpRequest();
			req.overrideMimeType("application/json");
			req.open("GET", url, true);
			req.onload = () => {
				try {
					resolve(JSON.parse(req.responseText));
				} catch (e) {
					resolve({});
				}
			};
			req.send(null);
		} else {
			resolve({...window.JSON_DATA.applications[name], api: window.JSON_DATA.api});
		}
	});
}

const DEFAULT_IFRAME_STYLE = {
	width: "100%",
	height: "100%",
	border: 0,
};

const DEFAULT_IFRAME_ATTRS = {
	allowfullscreen: "",
	frameborder: "0",
	allow: "autoplay;",
	autoplay: "",
};

function initIframeGame(searchParamsObj, iframeStyleObj = DEFAULT_IFRAME_STYLE, iframeAttrsObj = DEFAULT_IFRAME_ATTRS) {
	const baseSrc = `${sys.params.path + sys.params.game.html5Dir}/${sys.params.game.html5Index}`;
	const separator = baseSrc.indexOf("?") === -1 ? "?" : "";

	const iframe = document.createElement("iframe");
	const searchParamsStr = Object.entries(searchParamsObj).map(([k, v]) => `&${k}=${encodeURI(v)}`).join('');
	const flashvarsStr = sys.params.game.flashvars === "search" ? `&flashvars=${encodeURIComponent(btoa(JSON.stringify(window.flashvars)))}`: "";
	iframe.src = `${baseSrc}${separator}${searchParamsStr}${flashvarsStr}`;

	for (const [k, v] of Object.entries(iframeStyleObj || {})) { iframe.style[k] = v; }
	for (const [k, v] of Object.entries(iframeAttrsObj || {})) { iframe.setAttribute(k, v); }

	const gameContent = document.getElementById("game-content");
	gameContent.appendChild(iframe);
	html5.init();
	html5.requestFullscreen();
}

function initGameContent(app, params) {
	sys.init(app, params);

	if (!webgl.isSupported()) { // hack for Mali-4XX
		webgl.disable();
	}

	if (!!window.MSInputMethodContext && !!document.documentMode) {
		logger.warn("disabled PointerEvent for Internet Explorer 11");
		delete window.PointerEvent;
	}

	const gameDir = sys.params.game.html5Dir;

	if (sys.params.game.engine === "amatic") {
		const iframe = document.createElement("iframe");
		iframe.src = `${sys.params.path + sys.params.game.html5Dir}/mobile/${sys.params.game.html5Index}`;
		iframe.style.width = iframe.style.height = "100%";
		iframe.style.border = 0;
		iframe.setAttribute("allowfullscreen", "");

		const game_content = document.getElementById("game-content");
		game_content.appendChild(iframe);
		html5.init();
		html5.requestFullscreen();
	} else if (sys.params.game.engine === "aristocrat") {
		const iframe = document.createElement("iframe");
		iframe.src = `${sys.params.path + sys.params.game.html5Dir}/${sys.params.game.html5Index}`;
		iframe.style.width = iframe.style.height = "100%";
		iframe.style.maxWidth = "1280px";
		iframe.style.maxHeight = "720px";
		iframe.style.margin = "auto";
		iframe.style.display = "block";
		iframe.style.border = 0;
		iframe.setAttribute("allowfullscreen", "");

		const game_content = document.getElementById("game-content");
		game_content.appendChild(iframe);
		html5.init();
		html5.requestFullscreen();
	} else if (sys.params.game.engine === "netent" || sys.params.game.engine === "generic") {
		const iframe = document.createElement("iframe");
		const base_src = `${sys.params.path + sys.params.game.html5Dir}/${sys.params.game.html5Index}`;
		if (sys.params.game.flashvars === "search") {
			const separator = (base_src.indexOf("?") !== -1) ? "&" : "?";
			iframe.src = `${base_src}${separator}flashvars=${encodeURIComponent(btoa(JSON.stringify(window.flashvars)))}`;
		} else {
			iframe.src = base_src;
		}
		iframe.style.width = iframe.style.height = "100%";
		iframe.style.border = 0;
		iframe.setAttribute("allowfullscreen", "");
		iframe.setAttribute("frameborder", "0");
		iframe.setAttribute("allow", "autoplay;");
		iframe.setAttribute("autoplay", "");

		const game_content = document.getElementById("game-content");
		game_content.appendChild(iframe);
		html5.init();
		html5.requestFullscreen();
	} else if (sys.params.game.engine === "aviator") {
		const iframe = document.createElement("iframe");
		const customer = `c=${encodeURI(sys.params.billing)}`;
		const device = `d=${encodeURI(sys.params.token)}`;
		const home_page = `h=${encodeURI(sys.params.home_page)}`;
		const curr = `curr=${encodeURI(sys.params.currency || params.cur)}`;
		const lang = `l=${encodeURI(sys.params.language)}`;
		const timestamp = `timestamp=${(Date.now() / 1000) | 0}`;
		const mode = `mode=all`;

		const base_src = `${sys.params.path + sys.params.game.html5Dir}/${sys.params.game.html5Index}`;
		const separator = (base_src.indexOf("?") !== -1) ? "&" : "/?";
		iframe.src = `${base_src}${separator}${customer}&${device}&${home_page}&${curr}&${lang}&${mode}&${timestamp}`;
		if (sys.params.wgdc) iframe.src += `&u=${encodeURI(sys.params.wgdc)}`;
		if (sys.params.game.api && !sys.params.wgdc) iframe.src += `&u=${encodeURI(sys.params.game.api)}`;
		iframe.style.width = iframe.style.height = "100%";
		iframe.style.border = 0;
		iframe.setAttribute("allowfullscreen", "");
		iframe.setAttribute("frameborder", "0");
		iframe.setAttribute("allow", "autoplay;");
		iframe.setAttribute("autoplay", "");

		const game_content = document.getElementById("game-content");
		game_content.appendChild(iframe);
		html5.init();
		html5.requestFullscreen();
	} else if (sys.params.game.engine === "shooter") {
		sys.params.path = "//cdn.abx-play.fun/";
		initIframeGame({
			billingGroup: sys.params.billing,
			billingId: sys.params.token,
			nickname: sys.params.username,
			// homeUrl: sys.params.home_page,
			currency: sys.params.currency || params.cur,
			lang: sys.params.language,
			gu: sys.params.game_run_url || "",
			preset: sys.params.game_preset || "generic",
			group: sys.params.jackpot_group || "",
			timestamp: `${(Date.now() / 1000) | 0}`,
		});
	} else if (sys.params.loader === "html5"
		|| (typeof sys.params.game.load_only !== "undefined" && sys.params.game.load_only === "html5")
		|| (sys.params.game.supportHtml5 && sys.params.game.type !== "slot")) {
		if (sys.params.game.supportHtml5) {
			html5.init();

			if (sys.params.game.is_use_soundjs) {
				sys.loadScript(`${sys.params.path + gameDir}/lib/soundjs.min.js`)
					.catch((error) => {
						logger.error(`The script ${error.target.src} is not accessible.`); // eslint-disable-line
					});
			}

			isNeedShowPreloader = Array.isArray(sys.params.game.supp)
				? sys.params.game.supp.some((subSup) => PRELOADER_SUPPS.includes(subSup))
				: PRELOADER_SUPPS.includes(sys.params.game.supp);

			loadGame(gameDir);

			if (isNeedShowPreloader) {
				loadAndStartPreloader()
					.catch(() => {
						logger.error(`Wrong preloader`);
					})
					.finally(() => {
						isPreloaderComplete = true;
						checkIsNeedStartGame();
					});
			}
		} else {
			const el = document.getElementById("game-content");
			el.className = "error";
			const msg = document.createElement("div");
			el.appendChild(msg);
			msg.className = "error-message";
			msg.innerHTML = "Something went wrong. Please try again later. <br />";
		}
	}
}

function loadGame() {
	const gameDir = sys.params.game.html5Dir;
	const loader = sys.params.game.html5Loader;

	sys.loadScript(`${sys.params.path + gameDir}/${loader}`)
		.catch((error) => {
			logger.error(`The script ${error.target.src} is not accessible.`); // eslint-disable-line
		})
		.then(() => {
			isGameLoaded = true;

			checkIsNeedStartGame();
		});
}

function checkIsNeedStartGame() {
	if (!isGameLoaded) return;
	if (isNeedShowPreloader) {
		if (isPreloaderComplete) {
			destroyPreloader();
			startInitializeGame();
		} else {
			preloadInitializeGame();
		}
	} else {
		startInitializeGame();
	}
}

function preloadInitializeGame() {
	if (!window.lime.preload) return;

	const gameDir = sys.params.game.html5Dir;
	const docuElement = document.getElementById("game-content");

	window.lime.preload(
		"game-content",
		docuElement.clientWidth,
		docuElement.clientHeight,
		"0",
		`${sys.params.path + gameDir}/`,
		extraParams
	);
}

function startInitializeGame() {
	const gameDir = sys.params.game.html5Dir;
	const docuElement = document.getElementById("game-content");

	html5.requestFullscreen();

	window.lime.embed(
		"game-content",
		docuElement.clientWidth,
		docuElement.clientHeight,
		"0",
		`${sys.params.path + gameDir}/`,
		extraParams
	);

	if (!window.PIXI) {
		window.onload = () => {
			html5.toggleOrientationMessage();
		};
	} else {
		html5.toggleOrientationMessage();
		if (sys.params.game.engine === "pixi") {
			setTimeout(() => {
				const el = document.getElementsByName("viewport")[0];
				el.setAttribute("content", "height=device-height, width=device-width, initial-scale=1.0, "
					+ "maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, minimal-ui");
			}, 3000);
		}
	}
}

function init_loader(params) {
	const REQUIRED_FIELDS = ["game", "token", "billing", "language"];
	for (const field of REQUIRED_FIELDS) {
		if (!(field in params)) {
			throw new ReferenceError(`Required field "${field}" is not defined in "init_loader" function argument`);
		}
	}
	if (!(params.currency || params.cur)) {
		throw new ReferenceError(`Required field "cur"/"currency" is not defined in "init_loader" function argument`);
	}

	const sysParams = {
		ref: "",
		ios8bar: "resize",
		home_page: "/",
		preloader_logo: 1,
		button: "classic",
		bgcolor: "#000",
		path: "/media/",
		currency: params.currency || params.cur,
		...params
	};

	if (ASSETS_PATH) {
		sysParams.path = ASSETS_PATH;
	}

	// Check if the document is ready
	if (document.readyState === "complete" || document.readyState === "loaded" || document.readyState === "interactive") {
		loadGameConfig(sysParams);
	// Wait for DOM content loading
	} else if (document.addEventListener) {
		document.addEventListener("DOMContentLoaded", () => loadGameConfig(sysParams), false);
	} else {
		window.attachEvent("onload", () => loadGameConfig(sysParams));
	}
}

window.postload_init = initGameContent;
window.init_loader = init_loader;



// WEBPACK FOOTER //
// ./main.js